export enum OrderType {
  Follow = 'Follow',
  Like = 'Like',
  View = 'View',
  Comment = 'Comment',
  Share = 'Share',
  Save = 'Save',
  Unknown = 'Unknown'
}
